import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-business-48hour-deposit.component.scss';
var FormItemBusiness48hourDeposit = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemBusiness48hourDeposit, _super);
    function FormItemBusiness48hourDeposit(element) {
        return _super.call(this, element) || this;
    }
    FormItemBusiness48hourDeposit.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.submitBtn = Array.from(this.element.querySelectorAll(".js-apply-now__button-business_48hr-deposit"));
        this.businessType = this.element.querySelector(".js-business-type");
        this.helpDropDown = this.element.querySelector(".js-enquiry-type");
        if (this.helpDropDown) {
            this.displayEnquiryForm(this.helpDropDown.value);
        }
    };
    FormItemBusiness48hourDeposit.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.map(function (item) { return item.addEventListener("click", function (event) {
            var _button = event.target;
            var _form = _button.closest("form");
            var formFields = _form.querySelectorAll("input, select");
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        }); });
        if (this.businessType) {
            this.businessType.addEventListener("change", function () { return _this.validateBusinessType("validate"); });
        }
        if (this.helpDropDown) {
            this.helpDropDown.addEventListener("change", function () { return _this.displayEnquiryForm(_this.helpDropDown.value); });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pElement) {
                    pElement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (pEvent) {
            _this.displayEnquiryForm("Enquiry");
        }, false);
    };
    FormItemBusiness48hourDeposit.prototype.validateBusinessType = function (type) {
        this.businessOtherDropdown();
        if ((this.businessType.value === "Private_Company") || (this.businessType.value === "Close_Corporation")) {
            var field = this.form.querySelector("input.form__input--identification");
            if (field) {
                var formGroup = field.closest(".form__group");
                formGroup.classList.remove("form__group--error");
                var label = formGroup.querySelector("label");
                label.innerText = "Business Registration Number";
                field.setAttribute("name", "business-reg-number");
                field.classList.remove("form__input--identification");
                field.classList.add("form__input--business-registration");
                field.placeholder = "Enter your business registration number";
            }
        }
        else {
            var field = this.form.querySelector("input.form__input--business-registration");
            if (field) {
                var formGroup = field.closest(".form__group");
                formGroup.classList.remove("form__group--error");
                var label = formGroup.querySelector("label");
                label.innerText = "ID Number";
                field.setAttribute("name", "id-number");
                field.classList.remove("form__input--required");
                field.classList.add("form__input--identification");
                field.placeholder = "Enter your South African ID number";
            }
        }
    };
    FormItemBusiness48hourDeposit.prototype.businessOtherDropdown = function () {
        var field = this.businessType;
        var formGroup = field.closest(".form__group");
        var formGroups = Array.from(this.element.querySelectorAll(".form__group"));
        var formNote = this.element.querySelector(".apply-now__note");
        var formButtons = this.element.querySelector(".apply-now__buttons");
        var formOtherContainer = this.element.querySelector(".form__business-other--container");
        if (this.businessType.value === "OtherContent") {
            formGroups.map(function (item) {
                item.classList.add("form__group--hidden");
            });
            formNote.classList.add("hidden");
            formButtons.classList.add("hidden");
            if (formOtherContainer) {
                formOtherContainer.classList.add("active");
            }
        }
        else {
            formGroups.map(function (item) {
                item.classList.remove("form__group--hidden");
            });
            formNote.classList.remove("hidden");
            formButtons.classList.remove("hidden");
            if (formOtherContainer) {
                formOtherContainer.classList.remove("active");
            }
        }
        formGroup.classList.remove("form__group--hidden");
    };
    FormItemBusiness48hourDeposit.prototype.displayEnquiryForm = function (select) {
        var _tmpType = this.businessType.closest(".form__group");
        var __tmpId = this.element.querySelector("input[name=id-number]");
        var _tmpId = "";
        if (__tmpId) {
            _tmpId = __tmpId.closest(".form__group");
        }
        var __tmpBusiness = this.element.querySelector("input[name=business-reg-number]");
        if (__tmpBusiness) {
            _tmpId = __tmpBusiness.closest(".form__group");
        }
        var __tmpCustomer = this.element.querySelector("input[name=existing-customer]");
        var _tmpCustomer = "";
        if (__tmpCustomer) {
            _tmpCustomer = __tmpCustomer.closest(".form__group");
        }
        switch (select) {
            case "Enquiry":
                _tmpType.style.display = "none";
                if (_tmpId !== "") {
                    // _tmpId.style.display = `none`;
                    _tmpId.classList.add("form__group--hidden");
                    _tmpId.querySelector("input").classList.remove("form__input--required");
                }
                if (_tmpCustomer) {
                    _tmpCustomer.classList.add("form__group--hidden");
                    // _tmpCustomer.style.display = `none`;
                }
                break;
            case "NewAccount":
                _tmpType.style.display = "block";
                if (_tmpId !== "") {
                    _tmpId.classList.remove("form__group--hidden");
                    // _tmpId.style.display = `block`;
                    _tmpId.querySelector("input").classList.add("form__input--required");
                }
                if (_tmpCustomer) {
                    _tmpCustomer.classList.remove("form__group--hidden");
                    // _tmpCustomer.style.display = `block`;
                }
                break;
        }
    };
    FormItemBusiness48hourDeposit.prototype.submitForm = function (form) {
        var _this = this;
        // success screens
        var loader = form.querySelector(".form__loader--container");
        var thankYou = form.querySelector(".form__thankyou--container");
        var fieldsContainer = form.querySelector(".form__fields--container");
        // fields
        var enquiryType = form.querySelector("select[name=enquiry-type]");
        if (enquiryType && (enquiryType.value === "Enquiry")) {
            // loader + hide form
            loader.classList.add("active");
            fieldsContainer.classList.add("hidden");
            // variables
            var emailAddress = form.querySelector("input[name=email-address]");
            var recipient = form.querySelector("input[name=recipient]");
            var subject = form.querySelector("input[name=subject]");
            var description = form.querySelector("input[name=description]");
            var firstname = form.querySelector("input[name=first-name]");
            var lastname = form.querySelector("input[name=last-name]");
            var phoneNumber = form.querySelector("input[name=phone-number]");
            var altPhoneNumber = form.querySelector("input[name=alternative-number]");
            var email = form.querySelector("input[name=email]");
            var _postData = {
                'email': (emailAddress ? emailAddress.value : ""),
                'recipient': (recipient ? recipient.value : ""),
                'subject': (subject ? subject.value : ""),
                'description': (description ? description.value : ""),
                'firstname': (firstname ? firstname.value : ""),
                'surname': (lastname ? lastname.value : ""),
                'contactNo': (phoneNumber ? phoneNumber.value : ""),
                'AltContactNo': (altPhoneNumber ? altPhoneNumber.value : ""),
                'email-address': (email ? email.value : "")
            };
            var _documents = thankYou.querySelector(".form__thankyou--documents");
            if (_documents) {
                _documents.style.display = "none";
            }
            // service
            var url = "/services/genericform.jsp";
            this.formsService.postForm(url, this.http.serialiseObject(_postData)).then(function (pResponse) {
                // service ok
                _this.analyticsService.dtmFormComplete("complete", "");
                loader.classList.remove("active");
                thankYou.classList.add("active");
            }).catch(function (pError) {
                // service failed
                _this.analyticsService.dtmFormComplete("complete", "");
                loader.classList.remove("active");
                thankYou.classList.add("active");
            });
        }
        else {
            // loader + hide form
            loader.classList.add("active");
            fieldsContainer.classList.add("hidden");
            // variables
            var description = form.querySelector("input[name=description]");
            var firstname = form.querySelector("input[name=first-name]");
            var lastname = form.querySelector("input[name=last-name]");
            var businessType = form.querySelector("select[name=business-type]");
            var businessName = form.querySelector("input[name=business-name]");
            var phoneNumber = form.querySelector("input[name=phone-number]");
            var altPhoneNumber = form.querySelector("input[name=alternative-number]");
            var email = form.querySelector("input[name=email]");
            var businessRegNumber = form.querySelector("input[name=business-reg-number]");
            var idnumber = form.querySelector("input[name=id-number]");
            var existingCustomer = form.querySelector("input[name=existing-customer]");
            var _postData = {
                'description': (description ? description.value : ""),
                'firstname': (firstname ? firstname.value : ""),
                'surname': (lastname ? lastname.value : ""),
                'businessType': (businessType ? businessType.value : ""),
                'businessName': (businessName ? businessName.value : ""),
                'contactNo': (phoneNumber ? phoneNumber.value : ""),
                'AltContactNo': (altPhoneNumber ? altPhoneNumber.value : ""),
                'email': (email ? email.value : ""),
                'businessRegNumber': (businessRegNumber ? businessRegNumber.value : ""),
                'idNumber': (idnumber ? idnumber.value : ""),
                'isExistingCustomer': ((existingCustomer && existingCustomer.checked) ? "YES" : "NO"),
                'source': this.formsService.isMobile()
            };
            // service
            var url_1 = "/services/SubmitApplicationFormBizBankV1.jsp";
            this.formsService.postForm(url_1, this.http.serialiseObject(_postData)).then(function (pResponse) {
                // service ok
                loader.classList.remove("active");
                if (pResponse.data === "invalid") {
                    _this.analyticsService.dtmRecordSiteError("noerrorcode | invalid fields | " + url_1);
                    fieldsContainer.classList.remove("hidden");
                }
                else {
                    _this.analyticsService.dtmFormComplete("complete", pResponse.data);
                    thankYou.classList.add("active");
                    var _documents = thankYou.querySelector(".form__thankyou--documents");
                    if (_documents) {
                        _documents.removeAttribute("style");
                        var _buttonContainer = _documents.querySelector(".form__thank--documents-button");
                        var _subject = "My Reference Number Is: " + pResponse.data;
                        var _body = "To Whom It May Concern\n\nAttached please find a copy of the following documents as requested:\n\nID of owners and signatories\nProof of address not older than 3 months\nCompany registration documents if a registered company";
                        var _mailtoText = "mailto:SmallEnterpriseSales@standardbank.co.za?subject=" + encodeURIComponent(_subject) + "&body=" + encodeURIComponent(_body);
                        var _newButton = document.createElement("a");
                        _newButton.classList.add("button", "button--large", "button--centered", "button--main");
                        _newButton.setAttribute("data-id", "link_content_ documents email click");
                        _newButton.setAttribute("data-text", "email documents button click");
                        _newButton.setAttribute("href", _mailtoText);
                        var _text = document.createTextNode("EMAIL DOCUMENTS");
                        _newButton.appendChild(_text);
                        _buttonContainer.innerHTML = "";
                        _buttonContainer.appendChild(_newButton);
                    }
                }
            }).catch(function (pError) {
                // service failed
                _this.analyticsService.dtmRecordSiteError("noerrorcode | service failure occurred | " + url_1);
                loader.classList.remove("active");
                fieldsContainer.classList.remove("hidden");
            });
        }
    };
    return FormItemBusiness48hourDeposit;
}(Base));
export { FormItemBusiness48hourDeposit };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-business-48hour-deposit/form-item-business-48hour-deposit.component.ts
// module id = 837
// module chunks = 0